import { Component, OnInit, Inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import * as XLSX from 'xlsx';
import { TooltipPosition } from '@angular/material/tooltip';
import { NotifierService } from 'angular-notifier';
import { FormControl } from '@angular/forms';
import { LocalStorageService } from 'ngx-store';
import { Router } from '@angular/router';
import { RemoteService } from 'app/services/remote.service';
@Component({
  selector: 'app-brokers-list',
  templateUrl: './brokers-list.component.html',
  styleUrls: ['./brokers-list.component.scss']
})
export class BrokersListComponent implements OnInit {
  positionOptions: TooltipPosition[] = ['right'];
  position = new FormControl(this.positionOptions[0]);
  showMore: boolean = true;
  images = [{
    name: '1'
  }
  ]
  constructor(public dialog: MatDialog,
    private router: Router) { }

  ngOnInit() {
  }

  openDialog(value) {
    var width;
    if (value === 'other') {
      width = "400px"
    } else {
      width = "700px"
    }
    const dialogRef = this.dialog.open(SelectBrokerDialogContent, {
      data: value,
      width: width
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result === true) {
        this.router.navigate(['/csv/import-csv-file'])
      }
    });
  }

  showBrokersList() {
    this.showMore = !this.showMore;
  }
}
@Component({
  selector: 'select-broker-dialog-content',
  templateUrl: 'select-broker-dialog-content.html',
})
export class SelectBrokerDialogContent implements OnInit {
  userDetails: any;
  fileName: any;
  keys: string[];
  otherUi: any;
  constructor(public dialogRef: MatDialogRef<SelectBrokerDialogContent>,
    private notifierService: NotifierService,
    private ls: LocalStorageService,
    private service: RemoteService,
    @Inject(MAT_DIALOG_DATA) public data: ConfirmUserDialogModel) {
    this.otherUi = data;
  }

  ngOnInit() {
  }

  onConfirm(): void {
    const payload = {
      "columns": this.keys
    }
    this.service.fetchBrokerCsv(payload).subscribe(res => {
      this.ls.set('csvColumns', res);
      this.dialogRef.close(true);
    })
  }

  onFileChange(ev) {
    let workBook = null;
    let jsonData = null;
    var count = 0;
    const reader = new FileReader();
    const file = ev.target.files[0];
    this.fileName = file.name;
    if (file.type == "text/csv" || file.type == "application/vnd.ms-excel" || file.type == "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet") {
      reader.onload = (event) => {
        const data = reader.result;
        workBook = XLSX.read(data, { type: 'binary' });
        jsonData = workBook.SheetNames.reduce((initial, name) => {
          const sheet = workBook.Sheets[name];
          initial[name] = XLSX.utils.sheet_to_json(sheet);
          return initial;
        }, {});
        if (jsonData.Sheet1.length > 0) {
          const keys = Object.keys(jsonData.Sheet1[0]);
          this.ls.set('csvFileData', jsonData.Sheet1);
          this.keys = keys;
        } else {
          return this.notifierService.notify('error', 'Invalid file.File should not be empty.');
        }
      }
      reader.readAsBinaryString(file);
    } else {
      this.notifierService.notify('error', 'Invalid file type. File must be xls,xlsx or csv');
    }
  }

  onDismiss(): void {
    this.dialogRef.close(false);
  }
}
export class ConfirmUserDialogModel {
  constructor(public dialogData: object) { }
}